export const brand = {
  name: "Suvera Academy",
  tagline: "Your Global Education Journey Starts Here.",
  description:
    "Suvera Academy is an international education consultancy helping students discover the right destination, institution and academic pathway with personalised, end-to-end guidance.",
  logo: "/assets/brand/suvera-academy-logo.webp",
  logoWhite: "/assets/brand/suvera-academy-logo-white.webp",
  favicon: "/assets/brand/suvera-academy-logo.webp",
  colors: {
    primary: "#1B2F5B",
    primaryDark: "#0D1833",
    background: "#FBFBFA",
    accents: { red: "#E63946", green: "#2A9D8F", blue: "#4EA8DE", amber: "#E9C46A" },
  },
  phone: "+91 7397396077",
  email: "info@suveragroups.com",
  whatsapp: "+91 7397396077",
  whatsappLink: "https://wa.me/917397396077",
  address: "Guindy, Chennai",
  workingHours: "",
  socialLinks: {
    instagram: "https://www.instagram.com/suveraacademy/",
    facebook: "https://www.facebook.com/profile.php?id=61594444114094",
    linkedin: "https://www.linkedin.com/company/suvera-academy/home/",
    youtube: "",
  },
};

export const contactValue = (v) => (v && v.trim() ? v : "To be provided by Suvera Academy");
